import axios from "axios";
import { API_URL } from "../../constants";

export const SavePostView = async (pid) => {
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    const idArr = sessionStorage.getItem('PIDS');
    var newIdArr = [];
    if (idArr === null) {
        newIdArr.push(pid);
        sessionStorage.setItem('PIDS', JSON.stringify(newIdArr));

        try {
            let res = await axios.get(API_URL + "posts/save_view/"+pid, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            });

        } catch (err) {

        }

    } else {
        newIdArr = JSON.parse(idArr);
        if (!newIdArr.includes(pid)) {
            newIdArr.push(pid);
            sessionStorage.setItem('PIDS', JSON.stringify(newIdArr));

            try {
                let res = await axios.get(API_URL + "posts/save_view/"+pid, {
                    headers: {
                        'Authorization': "Bearer " + token,
                    }
                });

            } catch (err) {

            }
        }
    }



}